import styles from 'css/src/components/public-pages/UpdatesPage.module.scss';

import React, { useEffect, useState } from 'react';

import { ApiService } from 'js/src/client';
import { AnnouncementCard } from 'js/src/components/common/AnnouncementCard';
import {
    PRODUCT_UPDATES_FORM,
    PRODUCT_UPDATES_MESSAGE,
} from 'js/src/components/common/email-capture/email-capture-consts';
import EmailCaptureInline from 'js/src/components/common/email-capture/EmailCaptureInline';
import EmailCapturePopup from 'js/src/components/common/email-capture/EmailCapturePopup';
import type { ReadonlyAnnouncement } from 'js/src/data/announcements/announcement-types';

const UPDATES_PAGE_POPUP_PLACEMENT_ID = 'updates-page-popup';

const UpdatesPage: React.FC = React.memo(function UpdatesPage() {
    const [announcements, setAnnouncements] = useState<readonly ReadonlyAnnouncement[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        ApiService.announcementsPublicList()
            .then(({ data }) => {
                setAnnouncements(data ?? []);
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <div className={styles['updates-page']}>
            <EmailCapturePopup
                placementId={UPDATES_PAGE_POPUP_PLACEMENT_ID}
                message={PRODUCT_UPDATES_MESSAGE}
                form={PRODUCT_UPDATES_FORM}
            />

            <div className={styles['updates-page__header']}>
                <h1 className={styles['updates-page__title']}>Product updates</h1>
                <p className={styles['updates-page__subtitle']}>
                    The latest features, improvements, and fixes from Lumen5.
                </p>
            </div>

            <div className={styles['updates-page__body']}>
                <div className={styles['updates-page__main']}>
                    {isLoading && (
                        <div className={styles['updates-page__loading']}>Loading updates...</div>
                    )}

                    {!isLoading && announcements.length === 0 && (
                        <div className={styles['updates-page__empty']}>
                            No updates yet. Check back soon!
                        </div>
                    )}

                    {!isLoading &&
                        announcements.map((announcement) => (
                            <div key={announcement.id} className={styles['updates-page__item']}>
                                <AnnouncementCard announcement={announcement} titleTag="h2" />
                            </div>
                        ))}
                </div>

                <aside className={styles['updates-page__sidebar']}>
                    <EmailCaptureInline
                        message={PRODUCT_UPDATES_MESSAGE}
                        form={PRODUCT_UPDATES_FORM}
                    />
                </aside>
            </div>
        </div>
    );
});

export default UpdatesPage;
